<p-sidebar [(visible)]="visible" position="right" (onHide)="closeSidebar()" styleClass="p-sidebar-md" appendTo="body"
  [baseZIndex]="10000">
  <div class="row alertPanelHeader">
    <div class="col-10">
      <div class="row">
        <label class="alertsTitle">{{'account.alerts' | translate}}</label>
      </div>
    </div>
    <div class="col-1">
      <i class="pi pi-refresh reloadAlerts float-right" (click)="getUserAlerts()"></i>
    </div>
    <div class="col-1">
      @if (alerts && alerts.length > 0) {
      <i class="pi pi-trash clearAlerts float-right" (click)="clearAlers()"></i>
      }
    </div>
  </div>

  <div>
    @for (alert of alerts; track $index) {
    <div>
      <div [class]="alert.IsNew ? 'notification-item newAlert' : 'notification-item'">
        <div class="row" style="margin-top: 10px;">
          <div class="col-10" (click)="goToContext(alert)">
            <div class="row">
              <div class="dropdown-item-title">{{alert.Subject}}</div>
            </div>
          </div>
          <div class="col-2">
            <i class="pi pi-times float-right removeAlertIcon actionIcon" (click)="removeAlert(alert)"></i>
          </div>
        </div>
        <div class="row">
          <div class="col-10" (click)="goToContext(alert)">
            <div class="row">
              <div class="dropdown-item-subtitle" [innerHTML]="alert.Text"></div>
            </div>
          </div>
          <div class="col-2" (click)="goToContext(alert)">
            @if (alert.Type === 1) {
            <i class="pi pi-comment float-right dialogIcon actionIcon"></i>
            }
            @if (alert.Type === 2) {
            <i class="pi pi-calendar float-right calendarIcon actionIcon"></i>
            }
            @if (alert.Type === 3) {
            <i class="pi pi-server float-right calendarIcon actionIcon"></i>
            }
          </div>
        </div>
      </div>
    </div>
    }
    @if (!alerts || alerts.length === 0) {
    <div>
      <div class="notification-item-noBorder" style="text-align: center;">
        <i class="pi pi-bell" style="font-size: 5rem; color: orange; margin-top: 2rem;"></i>
        <div class="dropdown-item-subtitle-noBorder">{{'account.noAlerts' | translate}}</div>
      </div>
    </div>
    }

  </div>
</p-sidebar>

<p-toast [showTransformOptions]="'translateY(100%)'" [showTransitionOptions]="'500ms'" [hideTransitionOptions]="'500ms'"
  [showTransformOptions]="'translateX(100%)'" key="newAlert">
  <ng-template let-message pTemplate="alertMessage">
    @if (alertMessage) {
    <div class="p-flex p-flex-column" style="flex: 1">
      <div class="p-text-left alertMessageBody">
        <h6>{{alertMessage.Subject}}</h6>
        <div [innerHTML]="alertMessage.Text"></div>
      </div>
    </div>
    }
  </ng-template>
</p-toast>